var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link-externo",class:_vm.parent,attrs:{"href":_vm.url,"target":"_blank","rel":"noopener"}},[_vm._t("default"),_c('span',{staticClass:"a11y-solo-lectura"},[_vm._v(" (Link externo).")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }